import QRService from '../services/QRService';

class QRController {
  async generateLink(eventDbId, eventTitle, methods) {
    try {
      const linkData = await QRService.generateLinkCredentials(eventDbId, eventTitle, methods);
      return {
        success: true,
        data: linkData
      };
    } catch (error) {
      return {
        success: false,
        error: error.message
      };
    }
  }

  async generateQR(eventDbId, eventTitle, methods) {
    try {
      const qrData = await QRService.generateQRCredentials(eventDbId, eventTitle, methods);
      return {
        success: true,
        data: qrData
      };
    } catch (error) {
      return {
        success: false,
        error: error.message
      };
    }
  }

  async generateBoth(eventDbId, eventTitle) {
    try {
      const credentials = await QRService.generateBothCredentials(eventDbId, eventTitle);
      return {
        success: true,
        data: credentials
      };
    } catch (error) {
      return {
        success: false,
        error: error.message
      };
    }
  }

  async copyToClipboard(text) {
    try {
      await QRService.copyToClipboard(text);
      return {
        success: true,
        message: 'Link copiado al portapapeles'
      };
    } catch (error) {
      return {
        success: false,
        error: 'Error al copiar el link'
      };
    }
  }

  downloadQR(qrCodeImage, eventTitle) {
    try {
      QRService.downloadQRImage(qrCodeImage, eventTitle);
      return {
        success: true,
        message: 'QR descargado exitosamente'
      };
    } catch (error) {
      return {
        success: false,
        error: 'Error al descargar el QR'
      };
    }
  }
}

export default new QRController();